import { Drawer, Spin, Row, Col } from "antd";
import {
  FilePdfOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { API } from "../../EndpPoints";

const styles = {
  card: {
    position: "relative",
    border: "1px solid #eee",
    borderRadius: 8,
    padding: 20,
    textAlign: "center",
    background: "#fff",
    cursor: "pointer"
  },

  icon: {
    fontSize: 40,
    color: "red"
  },

  name: {
    marginTop: 10,
    fontSize: 13,
    wordBreak: "break-word"
  },

  actions: {
    position: "absolute",
    top: 8,
    right: 8,
    display: "flex",
    gap: 10,
    fontSize: 18
  },

  previewContainer: {
    height: "100%",
    overflow: "hidden"
  }
};

const HistoryDrawer = ({ open, onClose, userName }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);


  const loadHistory = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API.GET_STORED_FILES}/${encodeURIComponent(userName)}`
      );

      const data = await response.json();

      setFiles(data.files || []);
    } catch (error) {
      console.error("History fetch error:", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (open) loadHistory();
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  return (
    <>
      <Drawer
        title="Resume History"
        placement="right"
        size={420}
        open={open}
        onClose={onClose}
      >
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={[16, 16]}>
            {files.map((item, index) => (
              <Col span={12} key={item.public_id || index}>
                <div
                  style={styles.card}
                  
                >
                  <FilePdfOutlined style={styles.icon} />

                  <div style={styles.name}>{item.name}</div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Drawer>
    </>
  );
};

export default HistoryDrawer;
